export enum Format {
	STANDARD = "standard",
	FUTURE = "future",
	HISTORIC = "historic",
	PIONEER = "pioneer",
	MODERN = "modern",
	LEGACY = "legacy",
	PAUPER = "pauper",
	VINTAGE = "vintage",
	PENNY = "penny",
	COMMANDER = "commander",
	BRAWL = "brawl",
	DUEL = "duel",
	OLDSCHOOL = "oldschool",
	OATHBREAKER = "oathbreaker",
	PAUPER_COMMANDER = "paupercommander",
}

export const formatHumanReadable = {
	[Format.STANDARD]: "Standard",
	[Format.FUTURE]: "Future",
	[Format.HISTORIC]: "Historic",
	[Format.PIONEER]: "Pioneer",
	[Format.MODERN]: "Modern",
	[Format.LEGACY]: "Legacy",
	[Format.PAUPER]: "Pauper",
	[Format.VINTAGE]: "Vintage",
	[Format.PENNY]: "Penny",
	[Format.COMMANDER]: "Commander",
	[Format.BRAWL]: "Brawl",
	[Format.DUEL]: "Duel",
	[Format.OLDSCHOOL]: "Old School",
	[Format.OATHBREAKER]: "Oathbreaker",
	[Format.PAUPER_COMMANDER]: "Pauper Commander",
} as const;

const pauperCommander = formatHumanReadable[Format.PAUPER_COMMANDER];

export enum FormatForSearch {
	STANDARD = "standard",
	FUTURE = "future",
	HISTORIC = "historic",
	PIONEER = "pioneer",
	MODERN = "modern",
	LEGACY = "legacy",
	PAUPER = "pauper",
	VINTAGE = "vintage",
	PENNY = "penny",
	COMMANDER = "commander",
	BRAWL = "brawl",
	DUEL = "duel",
	OLDSCHOOL = "oldschool",
	OATHBREAKER = "oathbreaker",
	PAUPER_COMMANDER = "paupercommander",

	// Search specific
	COMMANDER_PRECONS = "commanderPrecons",
	BRAWL_PRECONS = "brawlPrecons",
	JUMPSTART_PRECONS = "jumpstartPrecons",
	ALL_PRECONS = "precons",
}
